// extracted by mini-css-extract-plugin
export default {"popupInner":"ReCaptchaPopup__popupInner--35d","layout":"ReCaptchaPopup__layout--18x","recaptcha":"ReCaptchaPopup__recaptcha--1YE","description":"ReCaptchaPopup__description--2vJ"};